export default __webpack_public_path__ + "static/media/new-user.f666c071.png";